export default "__VITE_ASSET__BiZoHRIF__"